module.exports = __webpack_public_path__ + "img/insurance.d29aea1b.svg";